import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import {
  Alert,
  Tabs,
  Tab,
  TextField,
  Button,
  Box,
  Typography,
  MenuItem,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Cookie from "cookie-universal";
import { CLIENTS, PROJECTS, TAGS } from "../../../Api/Api";
import { Axios } from "../../../Api/axios";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";

function ProjectsCreate() {
  const [tabIndex, setTabIndex] = useState(0);
  const [titleEn, setTitleEn] = useState("");
  const [titleAr, setTitleAr] = useState("");
  const [slugEn, setSlugEn] = useState("");
  const [slugAr, setSlugAr] = useState("");
  const [descEn, setDescEn] = useState("");
  const [descAr, setDescAr] = useState("");
  const [startDate, setStartDate] = useState(dayjs()); // Initialize with dayjs()
  const [url, setUrl] = useState("");
  const [images, setImages] = useState([]); // State for multiple images
  const [backgroundImage, setBackgroundImage] = useState(""); // State for single background image
  const [alert, setAlert] = useState(null);
  const [alertVisible, setAlertVisible] = useState(true);

  const token = Cookie().get("dashboardLogin");
  const userRole = Cookie().get("userRole");
  const [clients, setClients] = useState([]); // State to store clients
  const [selectedClient, setSelectedClient] = useState("");
  const [tags, setTags] = useState([]); // State to store clients
  const [selectedTag, setSelectedTag] = useState("");

  // Fetch clients when the component is mounted
  useEffect(() => {
    Axios.get(`/panel/${CLIENTS}`) // Replace with your API endpoint
      .then((response) => {
        const clientOptions = response.data.map((client) => ({
          value: client.id, // Assuming the client has an 'id' and 'name'
          label: client.title_en, // Adjust based on the structure of your client data
        }));
        setClients(clientOptions); // Set the clients data
      })
      .catch((error) => {
        console.error("Error fetching clients:", error);
      });
  }, []); // Empty dependency array ensures this runs only once when the component is mounted

  useEffect(() => {
    Axios.get(`/panel/${TAGS}`) // Replace with your API endpoint
      .then((response) => {
        const tagOptions = response.data.map((tag) => ({
          value: tag.id, // Assuming the tag has an 'id' and 'name'
          label: tag.name_en, // Adjust based on the structure of your client data
        }));
        setTags(tagOptions); // Set the clients data
      })
      .catch((error) => {
        console.error("Error fetching Tags:", error);
      });
  }, []); // Empty dependency array ensures this runs only once when the component is mounted

  // Function to generate slug from text
  const generateSlug = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-") // Replace spaces with dashes
      .replace(/[^a-zA-Z0-9\u0600-\u06FF-]+/g, ""); // Keep Arabic, Latin, numbers, and dashes
  };

  // Automatically update slugs when names change
  useEffect(() => {
    setSlugEn(generateSlug(titleEn));
  }, [titleEn]);

  useEffect(() => {
    setSlugAr(generateSlug(titleAr));
  }, [titleAr]);

  const fetchProjects = async () => {
    try {
      const response = await Axios.get(`/panel/${PROJECTS}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "X-User-Role": userRole,
        },
      });

      setTitleEn(response.data.titleen || "");
      setTitleAr(response.data.titlear || "");
      setSlugEn(response.data.slugen || "");
      setSlugAr(response.data.slugar || "");
      setDescEn(response.data.descen || "");
      setDescAr(response.data.descar || "");
      setStartDate(response.data.startdate || "");
      setUrl(response.data.url || "");
    } catch (error) {
      console.error("Error fetching Project:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form data before submitting
    if (
      !titleEn ||
      !titleAr ||
      !slugEn ||
      !slugAr ||
      !descEn ||
      !descAr ||
      !selectedClient ||
      !selectedTag
    ) {
      setAlert({
        type: "error",
        message: "Please fill in all required fields.",
      });
      setAlertVisible(true);
      setTimeout(() => setAlertVisible(false), 2000);
      return;
    }

    console.log("Selected Client ID:", selectedClient);
    console.log("Selected Tag ID:", selectedTag);

    const formData = new FormData();
    formData.append("title_en", titleEn);
    formData.append("title_ar", titleAr);
    formData.append("slug_en", slugEn);
    formData.append("slug_ar", slugAr);
    formData.append("desc_en", descEn);
    formData.append("desc_ar", descAr);
    formData.append("start_date", startDate);
    formData.append("url", url);

    console.log("selectedClient before appending:", selectedClient);
    console.log("selectedTag before appending:", selectedTag);
    formData.append("client_id", selectedClient);
    formData.append("tag_id", selectedTag);

    // Log FormData contents
    const formDataObject = {};
    formData.forEach((value, key) => {
      formDataObject[key] = value;
    });
    console.log("Form data object:", formDataObject);

    // Append multiple images
    console.log("Images before appending:", images);
    images.forEach((image) => {
      console.log("Appending image:", image);
      formData.append("images[]", image);
    });

    // Append background image separately
    console.log("Background image before appending:", backgroundImage);
    if (backgroundImage) {
      formData.append("background_image", backgroundImage);
    }

    try {
      const response = await Axios.post(`/panel/${PROJECTS}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "X-User-Role": userRole,
        },
      });

      // If successful, clear form and show success message
      fetchProjects();
      setTitleEn("");
      setTitleAr("");
      setSlugEn("");
      setSlugAr("");
      setDescEn("");
      setDescAr("");
      setSelectedClient("");
      setSelectedTag("");
      setStartDate("");
      setUrl("");
      setImages([]); // Clear images
      setBackgroundImage(null); // Clear background image

      setAlert({
        type: "success",
        message: "Project added successfully!",
      });
      setTimeout(() => setAlertVisible(false), 2000);
      setAlertVisible(true);
    } catch (error) {
      console.error("Error adding Project:", error);
      if (error.response) {
        console.log("Validation errors:", error.response.data.errors); // Log the validation errors from Laravel
      }
      setAlert({
        type: "error",
        message: error.response?.data?.message || "Failed to add Project.",
      });
      setTimeout(() => setAlertVisible(false), 2000);
      setAlertVisible(true);
    }
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setImages(files);
  };

  const handleBackgroundImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setBackgroundImage(file);
    }
  };

  return (
    <>
      {alert && alertVisible && (
        <Alert
          severity={alert.type} // Ensure this uses 'type' instead of 'severity'
          onClose={() => setAlertVisible(false)}
          sx={{
            transition: "opacity 1s ease-out",
            opacity: alertVisible ? 1 : 0,
          }}
        >
          {alert.message}
        </Alert>
      )}

      <Grid size={12}>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ mx: "auto", p: 2, boxShadow: 3, borderRadius: 2 }}
        >
          <Tabs
            value={tabIndex}
            onChange={(e, newIndex) => setTabIndex(newIndex)}
            centered
          >
            <Tab label="Title" />
            <Tab label="العنوان" />
            <Tab label="Slug" />
            <Tab label="Slug Ar" />
            <Tab label="Description" />
            <Tab label="التفاصيل" />
            <Tab label="Client" />
            <Tab label="Service" />
            <Tab label="URL" />
            <Tab label="Start Date" />
          </Tabs>

          {tabIndex === 0 && (
            <TextField
              fullWidth
              margin="normal"
              className="mb-3 mt-3"
              label="Title (English)"
              value={titleEn}
              onChange={(e) => setTitleEn(e.target.value)}
            />
          )}
          {tabIndex === 1 && (
            <TextField
              fullWidth
              margin="normal"
              className="mb-3 mt-3"
              label="العنوان"
              value={titleAr}
              onChange={(e) => setTitleAr(e.target.value)}
            />
          )}
          {tabIndex === 2 && (
            <TextField
              fullWidth
              margin="normal"
              className="mb-3 mt-3"
              label="Slug (English)"
              value={slugEn}
              disabled
            />
          )}
          {tabIndex === 3 && (
            <TextField
              fullWidth
              margin="normal"
              className="mb-3 mt-3"
              label="Slug (Arabic)"
              value={slugAr}
              disabled
            />
          )}
          {tabIndex === 4 && (
            <TextField
              fullWidth
              margin="normal"
              className="mb-3 mt-3"
              label="Description (English)"
              value={descEn}
              onChange={(e) => setDescEn(e.target.value)}
            />
          )}
          {tabIndex === 5 && (
            <TextField
              fullWidth
              margin="normal"
              className="mb-3 mt-3"
              label="التفاصيل"
              value={descAr}
              onChange={(e) => setDescAr(e.target.value)}
            />
          )}
          {tabIndex === 6 && (
            <TextField
              id="outlined-select-client"
              className="mb-3 mt-3"
              fullWidth
              select
              label="Select Client"
              value={selectedClient}
              onChange={(e) => setSelectedClient(e.target.value)}
            >
              {clients.map((client) => (
                <MenuItem key={client.value} value={client.value.toString()}>
                  {/* Ensure string value */}
                  {client.label}
                </MenuItem>
              ))}
            </TextField>
          )}
          {tabIndex === 7 && (
            <TextField
              id="outlined-select-tag"
              className="mb-3 mt-3"
              fullWidth
              select
              label="Select Tag"
              value={selectedTag}
              onChange={(e) => setSelectedTag(e.target.value)}
            >
              {tags.map((tag) => (
                <MenuItem key={tag.value} value={tag.value.toString()}>
                  {/* Ensure string value */}
                  {tag.label}
                </MenuItem>
              ))}
            </TextField>
          )}
          {tabIndex === 8 && (
            <TextField
              fullWidth
              margin="normal"
              className="mb-3 mt-3"
              label="URL"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
            />
          )}
          {tabIndex === 9 && (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                sx={{ width: "100%" }}
                margin="normal"
                className="mb-3 mt-3"
                label="Start Date"
                value={dayjs.isDayjs(startDate) ? startDate : dayjs()} // Ensure value is always a dayjs object
                onChange={(date) => {
                  setStartDate(date ? dayjs(date) : dayjs()); // Ensure date is a dayjs object
                }}
              />
            </LocalizationProvider>
          )}
          {/* Upload Multiple Images */}
          <Box
            sx={{
              border: "2px dashed #1976d2",
              borderRadius: 2,
              p: 3,
              textAlign: "center",
              cursor: "pointer",
              position: "relative",
              bgcolor: "#f0f8ff",
              "&:hover": { bgcolor: "#e3f2fd" },
            }}
          >
            <input
              type="file"
              accept="image/*"
              multiple // Allow multiple files
              style={{
                opacity: 0,
                width: "100%",
                height: "100%",
                position: "absolute",
                top: 0,
                left: 0,
                cursor: "pointer",
              }}
              onChange={handleImageChange}
            />
            <CloudUploadIcon sx={{ fontSize: 50, color: "#1976d2" }} />
            <Typography variant="body1" color="primary">
              Click or Drag to Upload Images
            </Typography>
          </Box>

          {/* Show selected images preview */}
          {images.length > 0 && (
            <Box mt={2}>
              <Grid container spacing={2}>
                {images.map((image, index) => (
                  <Grid size={3} key={index}>
                    <Box textAlign="center">
                      <Typography variant="body2">{image.name}</Typography>
                      <img
                        src={URL.createObjectURL(image)}
                        alt="Preview"
                        style={{
                          width: "100%", // Adjust to make images responsive
                          height: "auto",
                          borderRadius: 8,
                          marginTop: 10,
                        }}
                      />
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}

          {/* Upload Background Image */}
          <Box
            sx={{
              border: "2px dashed #1976d2",
              borderRadius: 2,
              p: 3,
              textAlign: "center",
              cursor: "pointer",
              position: "relative",
              bgcolor: "#f0f8ff",
              "&:hover": { bgcolor: "#e3f2fd" },
              mt: 2,
            }}
          >
            <input
              type="file"
              accept="image/*"
              style={{
                opacity: 0,
                width: "100%",
                height: "100%",
                position: "absolute",
                top: 0,
                left: 0,
                cursor: "pointer",
              }}
              onChange={handleBackgroundImageChange}
            />
            <CloudUploadIcon sx={{ fontSize: 50, color: "#1976d2" }} />
            <Typography variant="body1" color="primary">
              Click or Drag to Upload Background Image
            </Typography>
          </Box>

          {/* Show selected background image preview */}
          {backgroundImage && (
            <Box mt={2} textAlign="center">
              <Typography variant="body2">{backgroundImage.name}</Typography>
              <img
                src={URL.createObjectURL(backgroundImage)}
                alt="Background Preview"
                style={{
                  width: "20%",
                  height: "auto",
                  borderRadius: 8,
                  marginTop: 10,
                }}
              />
            </Box>
          )}

          <Button
            variant="contained"
            color="primary"
            type="submit"
            fullWidth
            sx={{ mt: 2 }}
          >
            Submit
          </Button>
        </Box>
      </Grid>
    </>
  );
}

export default ProjectsCreate;
